import React from "react";

const CandidateFirstForm = ({ setInputs, setStep, inputs }) => {

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputs((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setStep(1);
    }

    return (
        <form onSubmit={handleSubmit}>
            <h3>Quel type de compte souhaitez-vous créer ?</h3>
            <fieldset>
                <div>
                    <input type="radio"
                           id="interim"
                           name="account-type"
                           value="interim"
                           checked={inputs["account-type"] !== null && inputs["account-type"] === "interim"}
                           onChange={handleChange}/>
                    <label htmlFor="interim">Je suis une agence d'intérim</label>
                </div>
                <div>
                    <input type="radio" id="company" name="account-type" value="company"
                           checked={inputs["account-type"] !== null && inputs["account-type"] === "company"}
                           onChange={handleChange}
                    />
                    <label htmlFor="company">Je suis une entreprise</label>
                </div>
                <div>
                    <input type="radio" id="candidate" name="account-type" value="candidate"
                           checked={inputs["account-type"] !== null && inputs["account-type"] === "candidate"}
                           onChange={handleChange}
                    />
                    <label htmlFor="candidate">Je suis un intérimaire</label>
                </div>
            </fieldset>
            <button type="submit" className="btn fill white">Suivant →</button>
        </form>
    )
 }

 export default CandidateFirstForm;